import React from 'react';
import { Badge, Icon, Text } from './styled';

const GroupBadge = ({ title }) => {
  return (
    <Badge>
      <Icon aria-hidden="true" />
      <Text>{title}</Text>
    </Badge>
  );
};
export default GroupBadge;
